<template>
    <div class="div_margin" style="background-color: #fff; margin: 20px;">
        <div class="flex_box">
            <div class="flex_box_left">
                <div class="flex_box_left_center">
                    <el-tabs v-model="tabSelected" :tab-position="tabPosition" @tab-click="changeRole">
                        <el-tab-pane v-for="(item, index) in roleDataArray" :key="index" :label="item.name" />
                    </el-tabs>
                </div>
            </div>

            <div class="flex_box_right">
                <pageIndex1 v-if="tabSelectIndex == 0"></pageIndex1>
                <div class="all-order" v-if="tabSelectIndex == 1">
                    <div class="all-order-content">

                        <template>
                            <el-table :data="list" :key="tableKey"
                                :header-cell-style="{ background: '#f8f8f9', color: '#515a6E' }">
                                <el-table-column prop="name" label="项目" align="center" />
                                <el-table-column prop="specs" label="规格" align="center" />
                                <el-table-column prop="price" label="单价(元)" align="center" />
                                <el-table-column prop="unit" label="单位" align="center" />
                                <el-table-column prop="displayOrder" label="显示顺序" align="center" />
                                <el-table-column label="操作" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="editHandle(scope.row)">编辑</el-button>
                                        <span class="u-split">|</span>
                                        <el-popover :ref="`popover-${scope.$index}`" trigger="click" visible-arrow="false"
                                            placement="top">
                                            <p style="text-align: right; margin-bottom: 15px">您确定要删除吗？</p>
                                            <div style="margin:0 auto;text-align: center;">
                                                <el-button size="mini" type="text"
                                                    @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">取消</el-button>
                                                <el-button type="primary" size="mini" @click="delItem(scope)">确定</el-button>
                                            </div>
                                            <span slot="reference"
                                                style="color: #d9001b;cursor: pointer;;font-size: 12px;">删除
                                            </span>
                                        </el-popover>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                </div>
            </div>
        </div>
       

        <el-dialog :title="title" :visible.sync="showModal" width="600px" :close-on-click-modal="false"
            @close="cancel('addForm')">
            <div style="width: 90%">
                <el-form ref="addForm" :model="form" :rules="rules" label-width="100px" size="small">
                    <el-form-item label="项目:" prop="name">
                        <el-input v-model="form.name" placeholder="请输入项目" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="规格:" prop="">
                        <el-input v-model="form.specs" placeholder="请输入规格" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="单价(元):" prop="price">
                        <el-input-number v-model="form.price" :min="0" :max="999999999" label="请输入单价"
                            controls-position="right">元</el-input-number>

                    </el-form-item>
                    <el-form-item label="单位:" prop="unit">
                        <el-input v-model="form.unit" placeholder="请输入单位" maxlength="50"></el-input>
                    </el-form-item>

                    <el-form-item label="显示顺序:" prop="displayOrder">
                        <el-input-number v-model="form.displayOrder" :min="0" :max="999999999" label="请输入显示顺序"
                            controls-position="right"></el-input-number>
                        <p class="u-tip">数字越小显示越靠前</p>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer">
                <el-button @click="cancel('addForm')" size="small">取消</el-button>
                <el-button type="primary" @click="submitHandle('addForm')" :loading="btnloading" size="small">保存</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>
  
<script>
import pageIndex1 from "./comp9/index1";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        pageIndex1,
    },
    data () {
        return {
            tableKey: "",
            tabPosition: 'left',
            tabSelected: '',
            tabSelectIndex: 0,
            roleDataArray: [
                { name: "基本设置" },
                { name: "参展展品和服务" },
            ],
            menuArray: [],
            checked: [],
            list: [],
            rolesIdsDataArray: [],
            defaultChecked: [],

            // Add参数
            addShowIndex: 0,
            title: '',
            btnloading: false,
            showModal: false,
            form: {
                id: "",
                name: "",
                specs: "",
                discountRatio: 0,//折扣率
                discountPrice: 0,
                discountMode: "fixed",//折扣模式
                price: 0,
                unit: "",
                displayOrder: 0,
            },
            rules: {
                name: [{ required: true, message: "请输入展具名称", trigger: "blur" }],
                // specs: [{ required: true, message: "请输入规格", trigger: "blur" }],
                unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
                displayOrder: [
                    { required: true, message: "显示顺序为必填项", trigger: "blur" },
                ],
            },

        }
    },
    mounted () {

        this.init()
    },
    methods: {
        ...mapActions({


            categoryPost: "hostSetModule/categoryPost",
            categoryPut: "hostSetModule/categoryPut",
            joinProductId: "hostSetModule/joinProductId",

            demolitionboothandinstallationconstructionPost: "hostSetModule/demolitionboothandinstallationconstructionPost",
            demolitionboothandinstallationconstructionGet: "hostSetModule/demolitionboothandinstallationconstructionGet",
            demolitionboothandinstallationconstructionPut: "hostSetModule/demolitionboothandinstallationconstructionPut",
            demolitionboothandinstallationconstructionDelete: "hostSetModule/demolitionboothandinstallationconstructionDelete",

        }),
        changeRole (tab, event) {
            this.tabSelectIndex = tab.index
            if (this.tabSelectIndex == 1) {
                this.$emit('fatherMethod9', true)
            } else {
                this.$emit('fatherMethod9', false)
            }
            console.log(tab.index)
        },
        addClick () {
            this.showModal = true
            this.title = '新增'
            this.addShowIndex = 1
        },
        editHandle (e) {

            this.title = '编辑'
            this.showModal = true

            this.form.id = e.id
            this.form.name = e.name
            this.form.specs = e.specs
            this.form.price = e.price
            this.form.unit = e.unit
            this.form.displayOrder = e.displayOrder
        },

        async init () {
            let res = await this.demolitionboothandinstallationconstructionGet();
            this.list = res
            this.tableKey = Math.random()

        },

        async submitHandle (name) {
            let valid = await this.validForm(name);
            if (!valid) return;
            this.btnloading = true;
            setTimeout(() => {
                this.btnloading = false;
            }, 5000);
            let res = null;
            if (this.title == '编辑') {
                res = await this.editForm();
            } else {
                res = await this.addForm();
            }
            if (res) {

                this.init();
                this.$notify({
                    title: '成功',
                    message: '操作成功！',
                    type: 'success'
                });
                this.cancel();
            } else {
                this.$notify.error({
                    title: '错误',
                    message: '操作失败，请重新尝试'
                });
                this.btnloading = false;
            }
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        cancel () {
            this.$refs["addForm"].resetFields();
            this.$emit("close");
            this.btnloading = false;
            this.showModal = false;
            this.form = {
                name: "",
                displayOrder: 0,
                discountRatio: 0,
                discountPrice: 0,
                price: 0,
                discountMode: "fixed",//折扣模式

            };
        },
        validField (name) {
            // 验证单个控件
            setTimeout((c) => {
                this.$refs.form.validateField(name);
            }, 400);
        },
        async addForm () {
            let opt = {
                name: this.form.name,
                specs: this.form.specs,

                price: this.form.price,
                unit: this.form.unit,
                displayOrder: this.form.displayOrder,

            };
            let res = await this.demolitionboothandinstallationconstructionPost(opt);
            return Promise.resolve(res);
        },
        async editForm () {
            let opt = {
                id: this.form.id,
                body: {
                    name: this.form.name,
                    specs: this.form.specs,
                    price: this.form.price,
                    unit: this.form.unit,
                    displayOrder: this.form.displayOrder,
                },
            };
            let res = await this.demolitionboothandinstallationconstructionPut(opt);
            return Promise.resolve(res);
        },
        async delItem (info) {
            info._self.$refs[`popover-${info.$index}`].doClose()

            const res = await this.demolitionboothandinstallationconstructionDelete(info.row.id)
            if (res) {
                this.$notify({
                    title: '成功',
                    message: '操作成功！',
                    type: 'success'
                })
                this.init()
            } else {
                this.$notify.error({
                    title: '错误',
                    message: '操作失败，请重新尝试！'
                })
            }
        },

    }
}
</script>
  
<style lang="scss" scoped>
.flex_box_right {
    overflow: auto;
    height: 100%;
    margin-bottom: 30px;
}

.flex_box {
    display: flex;
    margin-top: 20px;

    &_left {
        width: 220px;
        display: flex;
        justify-content: end;

        &_center {
            display: flex;
        }
    }

    &_right {
        width: 100%;
    }
}

.saveClass {
    text-align: center;
}

.div_margin {
    min-height: 890px;
}
</style>
  